import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Home from './component/Home'
import Contact from './component/Contact'
import Relation from './component/Relation'
import Communication from './component/Communication'
import Evenementiel from './component/Evenementiel'
import About from './component/About'
import References from './component/Experience'

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<Home />} />
        <Route path="/Communication" element={<Communication />}/>
        <Route path="/Relation" element={<Relation />}/>
        <Route path="/Evenementiel" element={<Evenementiel />}/>
        <Route path="/Audit-Gestion" element={<Contact />}/>
        <Route path="/Contact" element={<About />}/>
        <Route path="/References" element={<References />}/>
      </Route>
    </Routes>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

